import { Injectable } from '@angular/core';
import { CredentialsService } from './credentials.service';
import { Observable, of, Subject } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../environments/environment';
import { mergeMap } from 'rxjs/operators';
import { ApiService } from '../http/api.service';

export interface LoginContext {
    username: string;
    password: string;
    companyId: string;
}

@Injectable({
    providedIn: 'root'
})
export class AuthService {
    private readonly baseApi = environment.baseAuthApi;

    public reload = new Subject();

    constructor(private credentialsService: CredentialsService,
        private apiService: ApiService,
        private http: HttpClient) { }

    /**
     * Authenticates the user.
     * @param context The login parameters.
     * @return The user credentials.
     */
    login(context: LoginContext): Observable<any> {
        let data: any;

        // localStorage.setItem('userName', context.username);
        // localStorage.setItem('companyId', context.companyId);
        // localStorage.setItem('firstName', 'Chalermopol');
        // localStorage.setItem('lastName', 'Chueayen');
        // return of(data);

        // TODO implement user credentians

        // return this.http.post(`${this.baseApi}/login`, context)
        return this.http.post(`${this.baseApi}/login`, context)
            .pipe(mergeMap((data) => {
                if (data) {
                    this.credentialsService.setCredentials({
                        username: data['first_name']
                    });
                    localStorage.setItem('userName', context.username);
                    localStorage.setItem('companyId', data["model"]["company"].id);
                    localStorage.setItem('officeId', data["model"].officeId);
                    localStorage.setItem('firstName', data["model"].firstName);
                    localStorage.setItem('lastName', data['model'].lastName);
                    localStorage.setItem('userProfile', JSON.stringify(data['model']));
                    localStorage.setItem('access_token',data['model'].token);

                    // let role = JSON.stringify(data['model']['role']['menu']);
                    let role = data['model']['role']['menu'];

                    this.reload.next(role);

                    return of(data);
                }
                return of(null);
            }));
        // return null;

        // return this.http.post(`${this.baseApi}/login`, context)
        //     .pipe(mergeMap((data) => {
        //         if (data) {
        //             this.credentialsService.setCredentials({
        //                 username: data['first_name']
        //             });
        //             localStorage.setItem('userName', context.username);
        //             localStorage.setItem('companyId', context.companyId);
        //             localStorage.setItem('firstName', data["model"].firstName);
        //             localStorage.setItem('lastName', data['model'].lastName);
        //             localStorage.setItem('userProfile', JSON.stringify(data['model']));

        //             this.reload.next();

        //             return of(data);
        //         }
        //         return of(null);
        //     }));
        // return this.http.post(`${this.baseApi}/login`, context)
        //     .pipe(mergeMap((data) => {
        //         if (data) {
        //             this.credentialsService.setCredentials({
        //                 username: data['first_name']
        //             });
        //             localStorage.setItem('userName', context.username);
        //             localStorage.setItem('companyId', context.companyId);
        //             localStorage.setItem('firstName', data['first_name']);
        //             localStorage.setItem('lastName', data['last_name']);
        //             return of(data);
        //         }
        //         return of(null);
        //     }));
    }

    get userProfile(): any {
      try {
        return JSON.parse(localStorage.getItem('userProfile'));
      } catch (e) {
        return null;
      }
    }

    /**
     * Logs out the user and clear credentials.
     * @return True if the user was logged out successfully.
     */
    logout(): Observable<boolean> {
        localStorage.setItem('userName', null);
        localStorage.setItem('companyId', null);
        localStorage.setItem('officeId', null);
        localStorage.setItem('firstName', null);
        localStorage.setItem('lastName', null);
        localStorage.setItem('userProfile', null);
        localStorage.setItem('access_token', null);

        // Customize credentials invalidation here
        this.credentialsService.setCredentials();
        return of(true);
    }

    // signToken(): Observable<any> {
    //     return this.http.post(`${this.baseApi}/token`, {
    //         grant_type: environment.auth.grantType,
    //         client_id: environment.auth.clientId,
    //         client_secret: environment.auth.clientSecret,
    //     }).pipe(mergeMap((data) => {
    //         if (data && data['access_token']) {
    //             this.apiService.setToken(data['access_token']);
    //             this.apiService.setTokenType(data['token_type']);
    //             return of(data);
    //         }
    //         return of(null);
    //     }));
    // }
}
